import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=dd4f4e6c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4f4e6c')) {
      api.createRecord('dd4f4e6c', component.options)
    } else {
      api.reload('dd4f4e6c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=dd4f4e6c&", function () {
      api.rerender('dd4f4e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25hHyzRE479gO/JS/offershelp.vue"
export default component.exports